<template>
    <div>
        <div class="wrapper">

            <dashboard-navigation :myProps="fullname"></dashboard-navigation>
            <dashboard-sidebar :myProp="fullname"></dashboard-sidebar>
        
            <!-- Full Transaction Modal -->
            <div class="modal" id="fullTransactionModal">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                <form>
                    <!-- Modal Header -->
                    <div class="modal-header">
                    <h4 class="modal-title"><small>Transaction 1135609</small></h4>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>

                    <!-- Modal body -->
                    <div class="modal-body">
                    
                        <div class="row">
                        <div class="col-sm-6">
                            <div class="form-group">
                            <label>Transaction Number</label>
                            <br />
                            <input type="text" readonly="readonly" value="1135609" class="form-control" />
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group">
                            <label>Reference</label>
                            <br />
                            <input type="text" readonly="readonly" value="TXd3333o0" class="form-control" />
                            </div>
                        </div>
                        </div>
                        <div class="row">
                        <div class="col-sm-6">
                            <div class="form-group">
                            <label>Transaction Date</label>
                            <br />
                            <input type="text" readonly="readonly" value="2018-03-03" class="form-control" />
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group">
                            <label>Buyer Name</label>
                            <br />
                            <input type="text" readonly="readonly" value="Nenne Nwodo" class="form-control"/>
                            </div>
                        </div>
                        </div>
                        <div class="row">
                        <div class="col-sm-6">
                            <div class="form-group">
                            <label>Seller Name</label>
                            <br />
                            <input type="text" readonly="readonly" value="Nenne Nwodo" class="form-control"/>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group">
                            <label>Marketplace Business Name</label>
                            <br />
                            <input type="text" readonly="readonly" value="Jumia Market" class="form-control" />
                            </div>
                        </div>
                        </div>
                        <div class="row">
                        <div class="col-sm-6">
                            <div class="form-group">
                            <label>Product Amount</label>
                            <br />
                            <input type="text" readonly="readonly" value="NGN 50,000.00" class="form-control"/>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group">
                            <label>Shipping Amount</label>
                            <br />
                            <input type="text" readonly="readonly" value="NGN 500.00" class="form-control"/>
                            </div>
                        </div>
                        </div>
                        <div class="row">
                        <div class="col-sm-6">
                            <div class="form-group">
                            <label>Escrow Fee Paid</label>
                            <br />
                            <input type="text" readonly="readonly" value="NGN 50,000.00" class="form-control"/>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group">
                            <label>Marketplace Commission Value</label>
                            <br />
                            <input type="text" readonly="readonly" value="NGN 500.00" class="form-control"/>
                            </div>
                        </div>
                        </div>
                        <div class="row">
                        <div class="col-sm-6">
                            <div class="form-group">
                            <label>Escrow Fee Paid By</label>
                            <br />
                            <input type="text" readonly="readonly" value="Seller" class="form-control"/>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group">
                            <label>Payment Transaction Fee</label>
                            <br />
                            <input type="text" readonly="readonly" value="NGN 500.00" class="form-control"/>
                            </div>
                        </div>
                        </div>
                        <div class="row">
                        <div class="col-sm-6">
                            <div class="form-group">
                            <label>Payment Channel</label>
                            <br />
                            <input type="text" readonly="readonly" value="Card" class="form-control"/>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group">
                            <label>Payment Status</label>
                            <br />
                            <input type="text" readonly="readonly" value="Refunded" class="form-control"/>
                            </div>
                        </div>
                        </div>
                        <div class="row">
                        <!--<div class="col-sm-6">
                            <div class="form-group">
                            <label>Date Range?</label>
                            <br />
                            <input type="text" readonly="readonly" value="" class="form-control"/>
                            </div>
                        </div>-->
                        <div class="col-sm-6">
                            <div class="form-group">
                            <label>Payment Value</label>
                            <br />
                            <input type="text" readonly="readonly" value="Value1" class="form-control"/>
                            </div>
                        </div>
                        </div>
                    </div>
                </form>
                </div>
            </div>
            </div>


            <!-- Content Wrapper. Contains page content -->
            <div class="content-wrapper">
                <!-- Content Header (Page header) -->
                <div class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                    <div class="col-sm-12">
                        <h1 class="m-0 text-dark">Payment History</h1>
                     
                                <div class="attop"><p>
                                     In the event of a disagreement between Seller and Buyer, either party can raise a dispute by filling the form below. A dispute manager will respond to mediate within 24 hours of receiving your request.

                                    Please ensure to have the order number under dispute to hand to enable you successfully log  the dispute request

                                </p></div>
                             
                        <br />
                    </div><!-- /.col -->
                    </div><!-- /.row -->
                </div><!-- /.container-fluid -->
                </div>
                <!-- /.content-header -->

                <!-- Main content -->
                <section class="content">
                <div class="container-fluid">
                    <br />
                    <div class="row">
                        <div class="col-12 col-sm-12 col-md-12">
                            <div class="alert animated bounceIn alert-danger d-none search-alert">
                                <a class="close alert-close" aria-label="close" v-on:click="hideAlert">&times;</a>
                                <span>{{alertMessage}}</span>
                            </div>
                        </div>
                    <div class="col-12 col-sm-12 col-md-12">
                        <div class="card">
                        <div class="card-body">
                            
                            <div class="row">
                                <div class="col-12 col-sm-3">
                                    <div class="form-group">
                                        <label for="period">Period</label>
                                        <select class="form-control" v-on:change="filterPeriod()" v-model="period"> 
                                            <option value="All">All</option>
                                            <option value="This Week">This Week</option>
                                            <option value="This Month">This Month</option>
                                            <option value="60 Days Ago">60 Days Ago</option>
                                            <option value="90 Days Ago">90 Days Ago</option>
                                            <option value="Custom">Custom</option>
                                        </select>
                                        
                                    </div>
                                </div>
                                <div class="col-12 col-sm-3">
                                    <div class="form-group">
                                        <label for="from">Date From</label>
                                        <input type="date" class="form-control" v-model="from_date" :disabled="notCustom">
                                    </div>
                                </div>
                                <div class="col-12 col-sm-3">
                                    <div class="form-group">
                                        <label for="from">Date To</label>
                                        <input type="date" class="form-control" v-model="to_date" :disabled="notCustom">
                                    </div>
                                </div>
                                <div class="col-12 col-sm-3">
                                    <div class="form-group">
                                        <label>&nbsp;</label>
                                        <button class="btn btn-primary form-control" :disabled="notCustom" v-on:click="filterDates()">Filter</button>
                                    </div>
                                </div>
                                
                            </div>
                            <br />
                            <div class="table-responsive">
                                
                                    <datatable :columns="columns" :data="data" :filter-by="filter" class="table">
                                        <template scope="{ row }">
                                            <tr>
                                                <td><a v-on:click="launchFullTransactionModal(4)">{{row.transaction_number}}</a></td>
                                                <td>{{row.payment_ref}}</td>
                                                <td>{{row.amount | currency}}</td>
                                                <td>{{row.gateway_response}}</td>
                                                <td>{{row.payment_date}}</td>
                                            </tr>
                                        </template>
                                    </datatable>
                                
                            </div>
                            <div class="row">
                                <div class="col-xs-12 form-inline">
                                    <datatable-pager v-model="page" type="abbreviated" :per-page="per_page"></datatable-pager>
                                </div>
                            </div>
                        
                        </div>
                    </div>
                        
                    </div>
                    </div>
                    <br />

                </div><!--/. container-fluid -->
                </section>
                <!-- /.content -->
            </div>
            <!-- /.content-wrapper -->

            <dashboard-footer></dashboard-footer>
            
        </div>
    </div>
</template>

<style>
.attop{
    background: #F5F5DC !important;
    color: #000 !important;
}
</style>



<script>
const endpoint = 'http://18.208.164.251/api';

export default {
    data(){
        return{
            fullname: "",
            stanbic_trustpay_user_role: this.$session.get('stanbic_trustpay_user_role'),
            payments: [],
            columns: [
                { label: 'Order Number', sortable: true},
                { label: 'Reference', sortable: true},
                { label: 'Amount', sortable: true},
                { label: 'Status', sortable: true},
                { label: 'Transaction Date', sortable: true}
            ],
            data: [],
            original_data: [],
            alertMessage: '',
            notCustom: true,
            total: 0,
            query: {},
            pageSizeOptions: [5, 10, 15, 20],
            Pagination: true,
            period: "All",
            from_date: null,
            to_date: null,
            filter: '',
            page: 1,
            per_page: 10,
        };
    },
    methods:{
        launchFullTransactionModal: function(id){
           //fetch details from json (or api)
           $('#fullTransactionModal').modal('show');
        },
        hideAlert: function(){
            $(".alert").addClass("d-none");
        },
        filterPeriod: function(){
            console.log(this.period);

            if(this.period == "All"){
                this.data = this.original_data;
                this.notCustom = true;
                this.page = 1;
                this.to_date = null;
                this.from_date = null;
                return;
            }

            if(this.period == "This Week"){
                var thisWeek = [];

                for(var i = 0; i < this.original_data.length; i++){
                    var now = moment();
                    var input = moment(this.original_data[i].payment_date);
                    var isThisWeek = (now.isoWeek() == input.isoWeek())

                    if(isThisWeek){
                        thisWeek.push(this.original_data[i]);
                    }
                }

                this.data = thisWeek;
                this.notCustom = true;
                this.page = 1;
                this.to_date = null;
                this.from_date = null;
                return;
            }

            if(this.period == "This Month"){
                var thisMonth = [];

                for(var i = 0; i < this.original_data.length; i++){
                    //var now = moment();
                    var input = moment(this.original_data[i].payment_date);
                    var isThisMonth = input.isSame(new Date(), 'month');

                    if(isThisMonth){
                        thisMonth.push(this.original_data[i]);
                    }
                }

                this.data = thisMonth;
                this.notCustom = true;
                this.page = 1;
                this.to_date = null;
                this.from_date = null;
                return;
            }

            if(this.period == "60 Days Ago"){
                var sixtyDaysAgo = [];

                for(var i = 0; i < this.original_data.length; i++){
     
                    var sixty_days_ago = moment().subtract(60, 'days');

                    var isBetweenSixtyDays = moment(this.original_data[i].payment_date).isAfter(sixty_days_ago);

                    if(isBetweenSixtyDays){
                        sixtyDaysAgo.push(this.original_data[i]);
                    }
                }

                this.data = sixtyDaysAgo;
                this.notCustom = true;
                this.page = 1;
                this.to_date = null;
                this.from_date = null;
                return;
            }

            if(this.period == "90 Days Ago"){
                var ninetyDaysAgo = [];

                for(var i = 0; i < this.original_data.length; i++){
     
                    var ninety_days_ago = moment().subtract(90, 'days');

                    var isBetweenNinetyDays = moment(this.original_data[i].payment_date).isAfter(ninety_days_ago);

                    if(isBetweenNinetyDays){
                        ninetyDaysAgo.push(this.original_data[i]);
                    }
                }

                this.data = ninetyDaysAgo;
                this.notCustom = true;
                this.page = 1;
                this.to_date = null;
                this.from_date = null;
                return;
            }

            if(this.period == "Custom"){
                
                this.to_date = null;
                this.from_date = null;
                this.notCustom = false;
                return;

            }
        },
        filterDates: function(){
            
            if(this.from_date == null){
                this.alertMessage = "Please select a From date";
                $(".search-alert").removeClass("d-none");
            }
            if(this.to_date == null){
                this.alertMessage = "Please select a To date";
                $(".search-alert").removeClass("d-none");
            }

            if(moment(this.from_date).isAfter(this.to_date)){
                this.alertMessage = "Please select a From date that is before your To date";
                $(".search-alert").removeClass("d-none");
            }

            var betweenTheTwoDates = [];

            for(var i = 0; i < this.original_data.length; i++){

                var isBetweenDates = moment(this.original_data[i].payment_date).isBetween(this.from_date, this.to_date); // true

                if(isBetweenDates){
                    betweenTheTwoDates.push(this.original_data[i]);
                }
            }

            this.data = betweenTheTwoDates;
            this.page = 1;
            return;
        },

     
    },
    mounted(){
        var user_role = this.$session.get('stanbic_trustpay_user_role');

        var orderDetailsEndpoint = endpoint +'/seller/payments';

        this.$http.get(orderDetailsEndpoint, { headers: {'Authorization': 'Bearer ' + this.$session.get('trustpayauthtoken') } })
        .then( 
            response => { //success
                return response.json();
            }, 
            response => { //error
                //this.$router.push('/login');
                //alert("Error");
                return response.json();
            }
        )
        .then(data => { 
            console.log("payments");
            console.log(data);
            if(data.status == "success" && data.message == "seller_payments"){
                this.data = data.data;
                this.original_data = data.data;
                this.payments = data.data;
                this.total = data.data.length;
            }else{
                alert("Error. Could not fetch payments at this time");
            }
            
            }
        );

        
    },
    beforeCreate: function () {

        var userDetailsEndpoint = endpoint +'/customer';

        if(this.$session.get('stanbic_trustpay_user_role') == "seller"){
            userDetailsEndpoint = endpoint +'/seller/account';
        }

        this.$http.get(userDetailsEndpoint, { headers: {'Authorization': 'Bearer ' + this.$session.get('trustpayauthtoken') } })
            .then( 
                response => { //success
                    return response.json();
                    //console.log(response);
                }, 
                response => { //error
                    //alert("Error. Could not fetch user at this time");
                    this.$router.push('/login');
                }
            )
            .then(user => { 
                console.log(user); 
                if(user.status == "success" && user.message == "customer_details"){
                    this.status = "done";
                    this.fullname = user.data.firstname + " " + user.data.lastname;
                    console.log("stats "+this.status);
                }else if (user.status == "success" && user.message == "seller_details"){
                    
                    this.status = "done";
                    this.fullname = user.data.firstname + " " + user.data.lastname;
                    console.log("stats "+this.status);

                    if(user.data.verified == 0){
                        this.$router.push('/myescrow/verify');
                    }

                }else{
                    alert("Your session has timed out. Please login again");
                    this.$session.destroy();
                    this.$router.push('/login');
                    //this.$router.push('/login');
                }
                
                }
            );

    
    }
}
</script>


// WEBPACK FOOTER //
// src/components/dashboard/PaymentHistory.vue